module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-lazyload-412.bc326c4d.jpg";